import { Button } from '@components/button';
import { InternalLink } from '@components/link';
import { BaseHeader } from '@components/page/header';
import { Typography } from '@components/typography';
import { Box, Stack, useTheme } from '@mui/material';

export const NonexistentWorkspacePage = () => {
  const { spacing } = useTheme();
  return (
    <Stack height="100vh" width="100vw">
      <BaseHeader />
      <Box
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <Typography variant="h2">This workspace does not exist. </Typography>
        <Typography variant="h2">Please navigate back.</Typography>
        <InternalLink to="/" sx={{ marginTop: spacing(4) }}>
          <Button>Go back</Button>
        </InternalLink>
      </Box>
    </Stack>
  );
};
